// import ContextMenuInList from './ContextMenuInList';

export default {
  edit: {},
  list: {},
  // actions: {},
};
